import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import LinkApi from '../server/LinkApi';
import Link from '../../models/link';
import Company from '../Company';

class LinkCache extends ObjectCache {
  api = LinkApi;
  createNew = (title, description, link) => new Link(null, UserAccount.account._id, [], [], UserAccount.account._id, title, description, link, null, null, null, null, null, Company.company && Company.company._id || '');
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new Link(results._id, results.owner, results.users, results.teams, UserAccount.account._id, results.title, results.description, results.link, results.createdTime, results.updateTime, results.state, results.shareSetting, results.version, results.company, results.background);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new LinkCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
